import * as React from 'react';
import { SVGProps } from 'react';

const IconTranslateSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 15h-1.528l-.857-2.1h-3.63L8.128 15h-1.53l3.44-8.4h1.53L15 15Zm-5.673-3.5h2.715L10.8 8l-1.473 3.5Z"
    />
    <path d="M9.4 5.2H8.001L6.939 7.59 4.96 9.57l1.98 1.98-.989.99-1.98-1.98-1.98 1.98-.99-.99 1.98-1.98L1 7.59l.99-.99 1.98 1.98L5.95 6.6l.65-1.4H1V3.8h8.4v1.4ZM6.6 2.4H3.8V1h2.8v1.4Z" />
  </svg>
);
export default IconTranslateSizeS;
